import React from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'
import { useLiterals } from '~/components/Literals'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  item: (props) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    cursor: props.onClick ? 'pointer' : 'inherit',
  }),
  badge: {
    width: 8,
    height: 8,
    borderRadius: 9999,
    '&.open': { backgroundColor: '#A6CD30' },
    '&.close': { backgroundColor: '#f44336' },
  },
  labels: {
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
}))

function StorePeriod({ onClick, period }) {
  const classes = useStyles({ onClick })
  const { getLiteral } = useLiterals()

  const hourEnd = period?.endTime.includes(':00') ? period?.endTime.replace(':00', '') : period?.endTime

  return (
    <Box className={classes.item} onClick={onClick ? onClick : () => {}}>
      <Box className={`${classes.badge} ${period?.isOpen ? 'open' : 'close'}`} />
      <Typography className={classes.labels}>
        <span style={{ fontWeight: 600 }}>
          {period?.isOpen ? `${getLiteral('2090')} - ` : `${getLiteral('2091')} - `}
        </span>
        {period?.isOpen ? `${getLiteral('2558', [hourEnd])}h` : getLiteral('2559')}
      </Typography>
    </Box>
  )
}

StorePeriod.propTypes = {
  onClick: PropTypes.oneOf([PropTypes.func, null, undefined]),
  period: PropTypes.any,
}

export default StorePeriod
